import { API_V4 } from "@/services/config/main-axios";

class CurrenciesService {
  getCurrencies() {
    return API_V4.get("/core/currencies");
  }
  getCryptoPrice() {
    return API_V4.get("/core/top-cryptos");
  }
}

export default new CurrenciesService();
